module.exports = __webpack_public_path__ + "img/pie-chart.ee1dcc04.svg";